import type { FunctionComponent } from 'react'
import React from 'react'
import type { AspectRatio } from '@which/seatbelt'
import { Picture } from '@which/seatbelt'

import classnames from 'classnames'

import type { ImageWithSources } from '../../../generated/frontend'
import styles from './HeroImage.module.scss'

export const HeroImage: FunctionComponent<HeroImageProps> = ({
  src,
  alt,
  sources,
  dimensions,
  aspectRatio = 'two-to-one',
  className,
}) => {
  if (!src) {
    return null
  }

  return (
    <div className={classnames(styles.heroImageWrapper, className)} data-testid="hero-image">
      <Picture
        src={src}
        alt={alt}
        aspectRatioMain={aspectRatio}
        width={dimensions?.width}
        height={dimensions?.height}
        lazyLoad={false}
        sources={sources}
      />
    </div>
  )
}

///////// IMPLEMENTATION /////////

type HeroImageProps = Pick<ImageWithSources, 'src' | 'alt' | 'sources' | 'dimensions'> & {
  aspectRatio?: AspectRatio
  className?: string
}
